import { render } from "./QuestionStep.vue?vue&type=template&id=6f520bdc&scoped=true"
import script from "./QuestionStep.vue?vue&type=script&lang=js"
export * from "./QuestionStep.vue?vue&type=script&lang=js"

import "./QuestionStep.vue?vue&type=style&index=0&id=6f520bdc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/doineedavpn.com/doineedavpn.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f520bdc"]])

export default __exports__